/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Parent entity dell\'allegato pratica (add-pratica-allegati, Fase 4.d.3)
 */
export enum TargetAllegato {

    PRATICA = 'PRATICA',

    ANAGRAFICA_RICHIEDENTE = 'ANAGRAFICA_RICHIEDENTE',

    NUCLEO_FAMILIARE_COMPONENTE = 'NUCLEO_FAMILIARE_COMPONENTE'
}

